import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import {
  type BoxReward,
  type MarketBoxes,
} from '@/common/types/shop/marketBoxes';
import { rewardArray } from '@/components/ui/RewardBlockItems/rewardArray';
import RewardBlockItems from '@/components/ui/RewardBlockItems/RewardBlockItems';

import css from './style.module.scss';

interface props {
  reward: BoxReward;
  variant: 'big' | 'medium' | 'small';
  packName: MarketBoxes;
  classNames?: string;
}

const RewardList: React.FC<props> = ({ reward, classNames, variant }) => {
  const [rewardItems, setRewardItems] = useState(() => rewardArray(reward));

  useEffect(() => {
    setRewardItems(rewardArray(reward));
  }, [reward]);

  if (!rewardItems.length) return null;

  return (
    <div className={cn(css.rewardContainer, classNames)}>
      {rewardItems.map((el, index) => (
        <RewardBlockItems key={index} {...el} variant={variant} />
      ))}
    </div>
  );
};

export default RewardList;
